module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-114x114-c0da633ac7eeb6cd019756e99332544a.png";